import React from 'react';

const ResponsibleGaming = () => {
  return (
    <div className="px-3 mx-auto max-w-6xl py-10">
      <h2 className="text-xl font-semibold mb-3">
        Responsible Gaming and Player Protection Information Policy
      </h2>
      <div className='font-light text-black'>
        <p className="mb-3">
          The website is committed to endorsing responsible wagering as well as promoting the
          awareness of problem gambling and improving prevention, intervention and treatment.
          Responsible Gambling Policy sets out its commitment to minimising the negative effects of
          problem gambling and to promoting responsible gambling practices.
        </p>
        <p className="mb-3">
          We consider it as our responsibility to you, our customers, to ensure that you will keep
          on enjoying your wagering experience on our site, remaining at the same time fully aware
          of the social and financial harms associated with problematic gambling. In order to help
          our customers in gambling responsibly, we ensure that all our staff receive responsible
          gambling awareness training, while we also provide the following information and features
          on our site.
          <br />
          Customer-driven loss limits;
          <br />
          Self-exclusion option by contacting Customer Service;
          <br />
          Links to SICAD, GamCare, Gambling Therapy and other organisations;
          <br />
          Self protection and awareness information;
        </p>
        <p className="mb-3">
          Information and tools to protect player’s accounts and prevent underage gaming. Temporary
          Account Closure/ Self-exclusion
          <br />
          You may at Your discretion choose to restrict your access to your account and/or exclude
          Yourself from playing any Games on the website, temporarily or permanently. In order to
          restrict Your access to the Games or Self-exclude You must visit the relevant section at
          your Account or email Customer Support. Account blocking and Self-Exclusion requests take
          effect immediately.
        </p>
        <p className="mb-3">
          To revoke a restriction of your account, contact Customer Support. For your protection, it
          is possible that revocation of such restrictions will take effect seven days after the
          receipt of your request, provided that the time period that You have chosen has elapsed.
        </p>
        <h3 className="text-xl font-semibold">Maintaining control</h3>
        <p className="mb-3">
          Whilst the majority of our customers gamble within their means for some it can be more
          difficult. In order to maintain control of your gambling habits, we would like you to bear
          in mind the following points: <br />
          Gambling should be done in moderation and undertaken as a form of entertainment and not as
          a way of making a living; <br />
          Avoid chasing losses; <br />
          Keep track of the time and monitor the amount of money you spend; <br />
          If you need help, use the loss limits functionality to help you control the amount you can
          spend. These can be accessed from within the "Settings" panel, from the "Profile" menu,
          under "Account" or you can contact our Customer Support or Agents for help. Should you
          need a break from gambling, Self-Exclusion can be set by contacting our Customer Support;
        </p>
        <p className="mb-3">
          n case you would like to monitor your account activity regarding any transactions
          (deposit/ withdrawals/ Sports bets, Casino bets) please visit the relevant section at your
          account (History {'>'} Transactions or Account Statement ). In the case that you notice
          that any of the transactions made at your account was not initiated by You, then you
          should immediately notify Customer Support through email and change your password.
        </p>
        <p className="mb-3">
          As part of the registration process, You will have to choose Your username and password
          for logging into the website. It is Your sole and exclusive responsibility to ensure that
          Your login details are kept securely. You must not disclose or share Your login details
          with anyone. website is not responsible for any abuse or misuse of Your Account by third
          parties due to Your disclosure, whether intentional or accidental, whether active or
          passive, of Your login details to any third party.
        </p>
        <h3 className="text-xl font-semibold">You think you have a problem?</h3>
        <p className="mb-3">
          If you are concerned that gambling has had a negative impact on your or someone else's
          life, then the following questions may help you find out more about your gambling
          behaviour and whether it is problematic or not.
          <br />
          Have you ever neglected your studies or work due to gambling?
          <br />
          Do you gamble to pass time or out of boredom?
          <br />
          Do you play alone and for long periods of time?
          <br />
          Have others ever criticised your gambling?
          <br />
          Have you ever lost interest in family, friends or hobbies due to gambling? Has it ever
          happened to you to lie, borrow or even steal money to cover gambling losses?
          <br />
          Has it ever happened to you to lie, borrow or even steal money for gambling? Are you
          reluctant to spend money allocated for gambling on other goals? Do you gamble until you
          lose all your money?
          <br />
          After losing, do you feel the need to play as soon as possible to cover losses? Are there
          times that gambling follows after arguments, frustrations or disappointments?
          <br />
          Does gambling cause you depression or suicidal thoughts?
          <br />
          The more questions that you answer 'yes' to, the more likely it is that you are having
          gambling issues. To speak with someone who can give you professional advice and support,
          please contact one of the organisations detailed below:
        </p>
        <div className="flex flex-col mb-3 text-blue-600 font-medium">
          <a href="www.gamcare.org.uk">www.gamcare.org.uk</a>

          <a href="www.gamblingtherapy.org">www.gamblingtherapy.org</a>

          <a href="www.gamblersanonymous.org.uk">www.gamblersanonymous.org.uk</a>
        </div>
        <h3 className="text-xl font-semibold">Underage gambling</h3>
        <p className="mb-3">
          It is illegal for anyone under the age of 18 to open an account or to gamble on a website.
          It takes very serious measures in this direction. We carry out age verification checks on
          all customers who use payment methods which are available to under 18's. Αdditionally, we
          randomly perform age verification checks on customers using other payment methods.
        </p>
        <p className="mb-3 uppercase">
          PLEASE NOTE THAT ANYONE UNDER THE AGE OF 18 FOUND TO BE USING THIS SITE WILL HAVE ANY
          WINNINGS FORFEITED AND MAY ALSO BE REPORTED TO THE POLICE.
        </p>
      </div>
    </div>
  );
};

export default ResponsibleGaming;
